import config from '@epi-config';
import { call } from 'redux-saga/effects';
import { Authorize } from '../constants/authorize';
import { getRequest } from './ApiRepository';

export function* getSettings() {
  return yield call(
    getRequest,
    `${config.apiHost}/api/settings`,
    Authorize.Never
  );
}
